export const SentryDsn =
  'https://d52f448a443f90636cc594af739bc934@sentry.mdigital.kg/49'

export const SentryIgnoreApis = ['v1/close-app/']
